import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.css']
})
export class SupportTicketComponent extends BaseListCtl {


  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super("", locator, route);
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.supportticket')
      .then((property: string) => {
        _self.initApiEndpoint(property);
        _self.getUsecaseDetails();
        _self.keySuffix = _self.locator.config.get("CONTEXT_PATH") + "-";
        _self.appId = localStorage.getItem(_self.keySuffix + 'appId')?? '0';
        _self.userId = localStorage.getItem(_self.keySuffix + 'skey')?? '0';
        _self.form.searchParams['appId']=parseFloat( _self.appId);
        _self.form.searchParams['userId']=parseFloat( _self.userId);

      });

  }


  
  public isProfileTabActive: boolean = false;
  public attributeList: any = [];
  public keySuffix: any;
  public appId:any =0;
  public userId:any =0;

  override populateForm(form: any, data: any): void {
    form.id = data.id;
    form.title = data.title;
    form.status = data.status;
    form.category = data.category;
    form.description = data.description;

  }
  override resetSearchForm() {
    this.form.searchError = false;
    this.form.searchMessage = '';
    this.form.searchParams = {
      appId: parseFloat(this.appId),
      userId:parseFloat(this.userId)
    };
    this.search();
}

  public async getUsecaseDetails() {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory') +
      '/getDetails/support-ticket';
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.getUsecaseSchema(res.result.data['id']);
    });
  }

  public async getUsecaseSchema(usecaseId: any) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.attributeList = res.result.data;
    });
  }

  onReferenceValueChange(e: any, value: string) {
    this.form.searchParams[e.code] = parseFloat(value);
  }



  public getInputType(t: string) {
    if (t === 'date') {
      return t;
    } else if (t === 'number' || t === 'decimal') {
      return 'number';
    }
    if (t === 'text') {
      return 'text';
    }
    if (t === 'date') {
      return t;
    }
    if (t === 'time') {
      return t;
    }
    if (t === 'file') {
      return t;
    }
    if (t === 'textarea') {
      return t;
    }
    if (t === 'password') {
      return t;
    } else {
      return 'text';
    }
  }

  onValueChange(e: any, value: string) {
    this.form.searchParams[e.code] =
      e.type === 'number' ? parseFloat(value) : value;
  }

  public saveSupport() {
    var _self = this;
    _self.form.error = false;
    _self.form.message = "";
    _self.form.inputerror = {};

    _self.form.data['status']='Open';
    let url =
      _self.locator.config.get('endpoint.supportticket') + '/supportEmail';
    _self.locator.http.post(url, _self.form.data, function (res: any, error: any) {

      if (error) {
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;

      if (res.success) {
        _self.form.message = "Data is saved";
        _self.form.data['id'] = res.result.data;
        _self.populateForm(_self.form, _self.form.data);
        _self.search();

      } else {
        _self.form.inputerror = res.result.inputerror;
      }
      console.log('FORM', _self.form);
    });


  }
}
